// hooks/useFacebookHashedUserData.ts
import { useEffect, useState } from "react";
import { firstName, getEmailStorage, getExternalID, getPhoneStorage, lastName } from "@/core-nextv3/util/util";
import { sha256 } from "js-sha256";

type User = {
  email?: string;
  name?: string;
  phone?: string;
  address?: {
    city?: string;
    state?: string;
    zipcode?: string;
    country?: {
        label : string
    };
  };
};

export const useFacebookHashedUserData = (user?: User) => 
{
    const [ hashedData, setHashedData ] = useState<Record<string, string>>();

    useEffect(() => 
    {
        const hashUserData = async () => 
        {
            const externalId = await getExternalID();
            const email      = getEmailStorage(user, externalId);
            const phone      = getPhoneStorage(user, externalId);

            const data: Record<string, string> = {
                em          : sha256(email),
                ph          : sha256(phone), 
                external_id : sha256(externalId),
            };

            if (user?.name) 
            {
                const fn = firstName(user.name);
                const ln = lastName(user.name);
                if (fn) data.fn = sha256(fn);
                if (ln) data.ln = sha256(ln);
            }

            if (user?.address?.city) data.ct = sha256(user.address.city);
            if (user?.address?.state) data.st = sha256(user.address.state);
            if (user?.address?.zipcode) data.zp = sha256(user.address.zipcode);
            if (user?.address?.country?.label) data.country = sha256(user.address.country.label);

            setHashedData(data);
        };

        hashUserData();
    }, [ user ]);

    return { hashedData };
};